import { Navigation } from '../components/navigation';
import { Footer } from '../components/footer';

export default function ContactUs() {
  return (
    <div className="w-full bg-gradient-to-b from-green-100 via-white to-emerald-50 min-h-[100vh]">
      <Navigation shouldShowNav={true} />
      <main className="pt-32 pb-20 md:pt-40 md:pb-28">
        <div className="max-w-4xl mx-auto px-6 sm:px-12">
          {/* Header */}
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1.5 bg-emerald-100 text-emerald-700 rounded-full text-sm font-medium mb-4">
              Get In Touch
            </span>
            <h1 className="text-4xl md:text-5xl font-bold font-display text-emerald-900 mb-4">
              Contact Us
            </h1>
            <p className="text-lg text-gray-600 max-w-xl mx-auto">
              We&apos;d love to hear from you. Reach out for bookings, inquiries, or just
              to say hello.
            </p>
          </div>

          {/* Contact Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
            {/* Bookings & Inquiries */}
            <div className="bg-white rounded-2xl p-6 shadow-sm border border-emerald-100">
              <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center mb-4">
                <svg
                  className="w-6 h-6 text-emerald-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-emerald-900 mb-3">
                Bookings & Inquiries
              </h3>
              <div className="space-y-2 text-gray-600">
                <p className="flex items-center gap-2">
                  <span className="text-emerald-600">💬</span>
                  <a href="https://wa.me/918485835675" className="hover:text-emerald-600">
                    WhatsApp/Phone: +91 84858 35675
                  </a>
                </p>
              </div>
            </div>

            {/* On-Ground Support */}
            <div className="bg-white rounded-2xl p-6 shadow-sm border border-emerald-100">
              <div className="w-12 h-12 bg-amber-100 rounded-xl flex items-center justify-center mb-4">
                <svg
                  className="w-6 h-6 text-amber-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-emerald-900 mb-3">
                On-Ground Support
              </h3>
              <div className="space-y-2 text-gray-600">
                <p className="text-sm text-gray-500 mb-2">Mela Visits / Boat / Sangam</p>
                <p className="flex items-center gap-2">
                  <span className="text-amber-600">📞</span>
                  <a href="tel:+919910078872" className="hover:text-emerald-600">
                    +91 99100 78872
                  </a>
                </p>
                <p className="flex items-center gap-2">
                  <span className="text-amber-600">📞</span>
                  <a href="tel:+918065249725" className="hover:text-emerald-600">
                    +91 80652 49725
                  </a>
                </p>
              </div>
            </div>

            {/* Email */}
            <div className="bg-white rounded-2xl p-6 shadow-sm border border-emerald-100">
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4">
                <svg
                  className="w-6 h-6 text-blue-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-emerald-900 mb-3">Email Us</h3>
              <div className="space-y-2 text-gray-600">
                <p className="flex items-center gap-2">
                  <span className="text-blue-600">✉️</span>
                  <a
                    href="mailto:bookings@kumbhsukrit.com"
                    className="hover:text-emerald-600"
                  >
                    bookings@kumbhsukrit.com
                  </a>
                </p>
                <p className="flex items-center gap-2">
                  <span className="text-blue-600">✉️</span>
                  <a
                    href="mailto:gopal.rishi@sukritwellness.com"
                    className="hover:text-emerald-600"
                  >
                    gopal.rishi@sukritwellness.com
                  </a>
                </p>
              </div>
            </div>

            {/* Camp Location */}
            <div className="bg-white rounded-2xl p-6 shadow-sm border border-emerald-100">
              <div className="w-12 h-12 bg-orange-100 rounded-xl flex items-center justify-center mb-4">
                <svg
                  className="w-6 h-6 text-orange-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-emerald-900 mb-3">
                📍 Camp Location
              </h3>
              <div className="space-y-2 text-gray-600">
                <p className="font-semibold text-emerald-600 text-sm">
                  Open: 31 Dec 2025 – End of Feb 2026
                </p>
                <p className="font-semibold text-emerald-800">Sector 22, Magh Mela</p>
                <p className="text-sm leading-relaxed">
                  Prayagraj, Uttar Pradesh
                  <br />
                  211019, India
                </p>
                <a
                  href="https://www.google.com/maps/place/Kumbh+Sukrit+Camp/@25.3938104,81.9191783,477m/data=!3m1!1e3!4m6!3m5!1s0x39854bf48007e067:0x35f4c7d7b5e37e25!8m2!3d25.3941014!4d81.918992!16s%2Fg%2F11gjxvh252?entry=ttu&g_ep=EgoyMDI1MTIwOS4wIKXMDSoKLDEwMDc5MjA2OUgBUAM%3D"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 text-emerald-600 hover:text-emerald-700 font-medium text-sm mt-2 transition-colors"
                >
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                    />
                  </svg>
                  Open in Google Maps →
                </a>
              </div>
            </div>
          </div>

          {/* Office Address - Full Width */}
          <div className="bg-white rounded-2xl p-6 shadow-sm border border-emerald-100 mb-12">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center flex-shrink-0">
                <svg
                  className="w-6 h-6 text-purple-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                  />
                </svg>
              </div>
              <div>
                <h3 className="text-lg font-bold text-emerald-900 mb-2">
                  Office Address
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  2nd Floor, 61/62, Pocket C-5,
                  <br />
                  Rohini Sector-11, Delhi,
                  <br />
                  North West, Delhi, India
                </p>
              </div>
            </div>
          </div>

          {/* Company Info */}
          <div className="mt-12 text-center">
            <p className="text-sm text-gray-500">
              Kumbh Sukrit is offered by{' '}
              <a
                href="https://sukritwellness.com"
                className="text-emerald-600 hover:underline font-medium"
              >
                Sukrit Wellness Tours Private Limited
              </a>
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
